import {
  PipelineStage,
  PipelineContext,
  StageResult,
} from '../ProcessingPipeline'
import { RawTelemetryData } from '../../../domain/telemetry/raw/RawTelemetryData'
import { messageOf } from '../../../utils/errorMessage'

export class FileInputStage implements PipelineStage {
  name = 'File Input'

  constructor(private rawTelemetry: RawTelemetryData) {}

  async execute(context: PipelineContext): Promise<StageResult<void>> {
    const warnings: string[] = []

    try {
      if (!this.rawTelemetry.gps || this.rawTelemetry.gps.length === 0) {
        return {
          success: false,
          error: 'No GPS data available in raw telemetry',
        }
      }

      if (
        !this.rawTelemetry.gyroscope ||
        this.rawTelemetry.gyroscope.length === 0
      ) {
        warnings.push(
          'No gyroscope data available - lean angle will be calculated from GPS'
        )
      }

      if (
        !this.rawTelemetry.accelerometer ||
        this.rawTelemetry.accelerometer.length === 0
      ) {
        warnings.push(
          'No accelerometer data available - acceleration will be calculated from GPS'
        )
      }

      context.rawTelemetry = this.rawTelemetry

      return {
        success: true,
        warnings: warnings.length > 0 ? warnings : undefined,
      }
    } catch (error) {
      return {
        success: false,
        error: `File input failed: ${messageOf(error)}`,
      }
    }
  }
}
